var VERBOSE = false;
var OneByOneIncrementer = /** @class */ (function () {
    function OneByOneIncrementer(length) {
        if (length === void 0) { length = 1; }
        this._progress = -1.0;
        this._duration = 1.0;
        /**
         * Whether the progress array needs to be rebuilt
         */
        this._dirty = false;
        VERBOSE && console.log('create OneByOneIncrementer', length);
        this._length = length;
        this._build();
    }
    Object.defineProperty(OneByOneIncrementer.prototype, "length", {
        get: function () {
            return this._length;
        },
        /**
         * The length of the array to generate
         */
        set: function (value) {
            VERBOSE && console.log('setting length', this._length, 'to', value);
            if (value === this._length) {
                return;
            }
            this._length = value;
            this._build();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OneByOneIncrementer.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        /**
         * The duration of the incrementer
         */
        set: function (value) {
            if (value === this._duration) {
                return;
            }
            this._duration = value;
            this._build();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OneByOneIncrementer.prototype, "array", {
        /**
         * The array of values
         */
        get: function () {
            return this._array;
        },
        enumerable: false,
        configurable: true
    });
    OneByOneIncrementer.prototype._build = function () {
        this._buildArrays();
    };
    OneByOneIncrementer.prototype._buildArrays = function () {
        if (!this.array || this.array.length === this.length) {
            this._array = new Float32Array(this.length);
        }
    };
    Object.defineProperty(OneByOneIncrementer.prototype, "progress", {
        get: function () {
            return this._progress;
        },
        /**
         * The current progress of the incrementer. This is a value between 0 and 1.
         */
        set: function (value) {
            if (value === this._progress) {
                return;
            }
            VERBOSE && console.log('set progress', value);
            this._progress = value;
            this._dirty = true;
        },
        enumerable: false,
        configurable: true
    });
    OneByOneIncrementer.prototype.update = function () {
        if (!this._dirty) {
            VERBOSE && console.log('Nothing to update');
            return false;
        }
        this._calculateProgress();
    };
    OneByOneIncrementer.prototype._calculateProgress = function () {
        var increment = 1 / this.length;
        var activeIndex = Math.max(0, Math.round(this.progress / increment) - 1);
        for (var i = 0; i < this.length; i++) {
            this._array[i] = i === activeIndex ? 1 : 0;
        }
    };
    return OneByOneIncrementer;
}());
export { OneByOneIncrementer };
